module.exports = __webpack_public_path__ + "static/img/30004 (2).f76927b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30004 (2).webp
// module id = EAy3
// module chunks = 14